module.exports = __webpack_public_path__ + "18a489b67ce98912b1dbc7e5ccf9ed36.png";